export const FETCH_SITE_REPORT_DATA =
  'ipfabric/DownloadSiteReport/FETCH_SITE_REPORT_DATA';
